/**
 * The two messages the page sends the worker, and the one Background Sync tag it asks for.
 *
 * Their own module, with no imports and no side effects, because both sides need them and
 * one side is a service worker. `sw.ts` calls `self.addEventListener` at the top level, so
 * anything importing it for a constant would execute those listeners — which is fine in a
 * worker and throws in Node, taking `register.test.ts` with it.
 *
 * Two copies of a string is the alternative, and a drifted copy here fails silently: the
 * worker would simply never hear the message.
 */

/** Cache these URLs now. Sent with the entry chunks this build actually loaded. */
export const PRECACHE = "precache";

/** Stop waiting and take over. Sent only when a person taps Update in Settings. */
export const SKIP_WAITING = "skip-waiting";

/**
 * The Background Sync tag. The page registers it after every ball; the worker's `sync` handler
 * drains every match's queue when the browser fires it. One tag, because "drain everything" is
 * the only job, and the browser coalesces repeated registrations of the same tag.
 */
export const DRAIN_TAG = "sportsos-drain-outbox";
